import { useBackendApi } from "./backendApi";

export interface WebhookRequestData {
  requestPayload: string;
  statusCode: number;
  body: string
  headers: Record<string, string[]>
}

export function useWebhookSubscriptionTestService() {
  const backendApi = useBackendApi();


  const testSubscription = async (subscriptionId: number) => {
    return await backendApi.post(
      `/integrations/subscriptions/${subscriptionId}/test`,
      {}
    ) as WebhookRequestData;
  };

  return {
    testSubscription,
  }
}
